module.exports = RootreeVendor.ReactQuery;